// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 *
 * @export
 * @interface RiskPayload
 */
export interface RiskPayload {
  /**
   *
   * @type {number}
   * @memberof RiskPayload
   */
  project: number;
  /**
   *
   * @type {string}
   * @memberof RiskPayload
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof RiskPayload
   */
  description?: string;
  /**
   * RiskType id
   * @type {number}
   * @memberof RiskPayload
   */
  riskType?: number;
  /**
   * RiskStatus id (defaults to the first open status when omitted)
   * @type {number}
   * @memberof RiskPayload
   */
  status?: number;
  /**
   * RiskScaleValue id (axis = likelihood)
   * @type {number}
   * @memberof RiskPayload
   */
  likelihood: number;
  /**
   * RiskScaleValue id (axis = impact)
   * @type {number}
   * @memberof RiskPayload
   */
  impact: number;
  /**
   * User id
   * @type {number}
   * @memberof RiskPayload
   */
  owner?: number;
  /**
   *
   * @type {string}
   * @memberof RiskPayload
   */
  mitigationStrategy?: string;
  /**
   * RiskScaleValue id (axis = likelihood)
   * @type {number}
   * @memberof RiskPayload
   */
  residualLikelihood?: number;
  /**
   * RiskScaleValue id (axis = impact)
   * @type {number}
   * @memberof RiskPayload
   */
  residualImpact?: number;
  /**
   *
   * @type {string}
   * @memberof RiskPayload
   */
  targetDate?: string;
  /**
   *
   * @type {string}
   * @memberof RiskPayload
   */
  reviewDate?: string;
  /**
   * Array of Tag ids
   * @type {Array<number>}
   * @memberof RiskPayload
   */
  tags?: Array<number>;
}

export function RiskPayloadFromJSON(json: any): RiskPayload {
  return {
    project: json["project"],
    title: json["title"],
    description: !exists(json, "description") ? undefined : json["description"],
    riskType: !exists(json, "risk_type") ? undefined : json["risk_type"],
    status: !exists(json, "status") ? undefined : json["status"],
    likelihood: json["likelihood"],
    impact: json["impact"],
    owner: !exists(json, "owner") ? undefined : json["owner"],
    mitigationStrategy: !exists(json, "mitigation_strategy")
      ? undefined
      : json["mitigation_strategy"],
    residualLikelihood: !exists(json, "residual_likelihood")
      ? undefined
      : json["residual_likelihood"],
    residualImpact: !exists(json, "residual_impact")
      ? undefined
      : json["residual_impact"],
    targetDate: !exists(json, "target_date") ? undefined : json["target_date"],
    reviewDate: !exists(json, "review_date") ? undefined : json["review_date"],
    tags: !exists(json, "tags") ? undefined : json["tags"],
  };
}

export function RiskPayloadToJSON(value?: RiskPayload): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    project: value.project,
    title: value.title,
    description: value.description,
    risk_type: value.riskType,
    status: value.status,
    likelihood: value.likelihood,
    impact: value.impact,
    owner: value.owner,
    mitigation_strategy: value.mitigationStrategy,
    residual_likelihood: value.residualLikelihood,
    residual_impact: value.residualImpact,
    target_date: value.targetDate,
    review_date: value.reviewDate,
    tags: value.tags,
  };
}
